module.exports = __webpack_public_path__ + "static/media/05_a_background.fc1b7f57.jpg";